import * as React from 'react';
import { Shadows, Text, View, YStack } from 'smoothie';

interface FloatingCardProps {
    amount: string;
    label: string;
}

const FloatingCard = ({ amount, label }: FloatingCardProps) => (
    <View
        backgroundColor="white"
        borderRadius={8}
        padding={14}
        justifyContent="center"
        alignItems="center"
        borderWidth={1}
        borderColor="$gray200"
        {...Shadows.LARGE}
    >
        <YStack gap={2} alignItems="center">
            <Text
                color="$green1000"
                fontSize="$4"
                $sm={{ fontSize: '$5' }}
                fontWeight="600"
                textAlign="center"
            >
                {amount}
            </Text>
            <Text
                color="$gray1000"
                fontSize={10}
                $sm={{ fontSize: '$2' }}
                textAlign="center"
                numberOfLines={1}
            >
                {label}
            </Text>
        </YStack>
    </View>
);

export const InterestCard = () => (
    <FloatingCard amount="+$71.51" label="September interest" />
);

export const CashbackCard = () => (
    <FloatingCard amount="+$46.08" label="cash back earned" />
);

export default FloatingCard;
